/**
 * In-memory token store.
 * Token is never persisted to localStorage/sessionStorage (XSS protection).
 * Access token lives only in JS memory for the duration of the session.
 */
let accessToken: string | null = null

export const tokenStore = {
  get: (): string | null => accessToken,
  set: (token: string): void => {
    accessToken = token
  },
  clear: (): void => {
    accessToken = null
  },
}
